// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import React from 'react'
import { SitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { Route, Switch } from 'react-router-dom'
import componentFactory from './temp/componentFactory'
import RouteHandler from './RouteHandler'
import { isClient } from './helpers/isClient'
import { container } from './Foundation/DependencyInjection/container'
import { DIProvider } from './Foundation/DependencyInjection/containerHooks'
import {
  registerBinding,
  registerPerRequestBinding,
} from './Project/DiscoveryWebsiteJSS/DependencyInjection/serviceRegistration'
import { SWRConfig } from 'swr'
import { GlobalStyles } from '@christies/react/foundations'
import { ImageStoreProvider } from './Feature/Magazines/imagesStoreContext'

// This is the main JSX entry point of the app invoked by the renderer (server or client rendering).
// By default the app's normal rendering is delegated to <RouteHandler> that handles the loading of JSS route data.

// support languages in the URL prefix
// e.g. /da-DK/path, or /en/path, or /path
export const routePatterns = [
  '/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*',
  '/:lang([a-z]{2})/:sitecoreRoute*',
  '/:sitecoreRoute*',
]

interface AppRootProps {
  ssrState?: SSRState
}

// SitecoreContext: provides component resolution and context services via withSitecoreContext
// Router: provides a basic routing setup that will resolve Sitecore item routes and allow for language URL prefixes.
class AppRoot extends React.Component<AppRootProps> {
  constructor(props) {
    super(props)
  }

  render() {
    const { path, Router } = this.props

    const routeRenderFunction = (props) => <RouteHandler route={props} isSSR={!!this.props.ssrState} />

    // SSR has different place for registerBinding
    if (isClient) {
      registerBinding(container)
      // It changes to singleton scope on client side
      registerPerRequestBinding(container, this.props?.ssrState)
    }

    return (
      <ImageStoreProvider>
        <DIProvider container={container}>
          <SWRConfig
            value={{
              suspense: false,
            }}
          >
            <SitecoreContext componentFactory={componentFactory} layoutData={this.props.ssrState}>
              <Router location={path} context={{}}>
                <GlobalStyles />
                <Switch>
                  {routePatterns.map((routePattern) => (
                    <Route key={routePattern} path={routePattern} render={routeRenderFunction} />
                  ))}
                </Switch>
              </Router>
            </SitecoreContext>
          </SWRConfig>
        </DIProvider>
      </ImageStoreProvider>
    )
  }
}

export default AppRoot
